export default function archivedReportsDirective() {
  return {
    template: require('./archived-reports.html'),
    controller: 'ArchivedReportsController',
    controllerAs: 'archivedReportsVM',
    bindToController: true,
    replace: true,
  };
}
